import React from "react";
// REDUX
import { useSelector } from "react-redux";
// COMPONENTS
import VendorsTable from "./VendorsTable";
import VendorsForm from "./VendorsForm";
import VendorsDeleteModal from "./VendorsDeleteModal";
// AUTHORIZATION
import validatePermission from "../../../utils/validatePermissions";
import UnauthorizedPage from "../../unauthorized/UnauthorizedPage";
// INTERFACES
import { RootState } from "../../../app/store";

const VendorsPage = () => {
	// ************************************************ */
	// LOCAL STORAGE AND VARIABLES ******************** */
	const { permissions } = useSelector((state: RootState) => state.user);
	const { theme } = useSelector((state: RootState) => state.home);

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************* */
	// USE EFFECT ************************************** */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div>
			{validatePermission("view-tool-management-vendors", permissions) ? (
				<div className={`layout__contentPage__${theme}`}>
					<VendorsTable />
					<VendorsForm />
					<VendorsDeleteModal />
				</div>
			) : (
				<UnauthorizedPage />
			)}
		</div>
	);
};

export default VendorsPage;
